import React from 'react';
import { legShape } from 'constants/propTypes';
import { intlShape } from 'react-intl';
import PropTypes from 'prop-types';
import moment from 'moment';
import { StyledDiv } from './styles';

const JourneyLeg = ({ leg, direction, intl }) => (
  <>
    <h4>
      {intl.formatMessage({ id: `quoteConfirmation.journeyDetails.${direction}` })} - {moment(leg.timing.date).format('dddd Do MMMM YYYY')}{' '}
      <span style={{ fontWeight: '400' }}>
        {leg.origin.name} {intl.formatMessage({ id: 'quoteConfirmation.journeyDetails.to' })} {leg.destination.name}
      </span>
    </h4>
    <StyledDiv>
      <p data-testid="journeyDetails-trainNumber">
        {intl.formatMessage({ id: 'quoteConfirmation.journeyDetails.trainNumber' })}: {leg.serviceType.code} {leg.serviceName}
      </p>
      <p data-testid="journeyDetails-departing">
        {intl.formatMessage({ id: 'quoteConfirmation.journeyDetails.departing' })}: {leg.timing.departs}
      </p>
      <p data-testid="journeyDetails-arriving">
        {intl.formatMessage({ id: 'quoteConfirmation.journeyDetails.arriving' })}: {leg.timing.arrives}
      </p>
      <p data-testid="journeyDetails-class">
        {intl.formatMessage({ id: 'quoteConfirmation.journeyDetails.class' })}: {leg.classOfService.name}
      </p>
      <p data-testid="journeyDetails-fare">
        {intl.formatMessage({ id: 'quoteConfirmation.journeyDetails.fare' })}: {leg.products[0].name}
      </p>
      <p data-testid="journeyDetails-passengerCount">
        {intl.formatMessage({ id: 'bookingSearchResults.passengerCount' })}: {leg.products?.filter((p) => !p.cancelled)?.length}
      </p>
    </StyledDiv>
  </>
);

JourneyLeg.propTypes = {
  leg: legShape.isRequired,
  direction: PropTypes.string.isRequired,
  intl: intlShape.isRequired
};

export default JourneyLeg;
